import React, { useState } from 'react';
import './Chatbot.css';

const Chatbot = () => {
  // State to manage the chatbox open/close state
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]); // Store chat messages
  const [inputMessage, setInputMessage] = useState(''); // Store the message in the input field

  // Toggle chatbox visibility
  const toggleChatbox = () => {
    setIsOpen(!isOpen);
  };

 
  const CHATBOT_BASE = process.env.REACT_APP_CHATBOT_BASE_URL || 'http://127.0.0.1:5000';

  const handleSendMessage = () => {
    if (inputMessage.trim() === '') return;

    // User message
    const userMessage = { name: 'User', message: inputMessage };
    setMessages([...messages, userMessage]); 

    // Send to the server
    fetch(`${CHATBOT_BASE}/response`, {
      method: 'POST',
      body: JSON.stringify({ message: inputMessage }),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
 
        const botMessage = { name: 'Errie', message: data.answer };
        setMessages((prevMessages) => [...prevMessages, botMessage]); 
        setInputMessage(''); 
      })
      .catch((error) => {
        console.error('Error:', error);
        setInputMessage('');
      });
  };


  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      handleSendMessage();
    }
  };

  return (
    <div>
      {/* Chat Icon */}
      <div className="chatbox__button" onClick={toggleChatbox}>
        <button>
          <img
            src={require('../Assets/icons/chats.svg').default}
            alt="Chatbot Icon"
          />
        </button>
      </div>

      {/* Chatbox */}
      <div className={`chatbox ${isOpen ? 'chatbox--active' : ''}`}>
        <div className="chatbox__support">
          {/* Header */}
          <div className="chatbox__header">
            <div className="chatbox__image--header">
              <img
                src="https://img.icons8.com/color/48/000000/circled-user-female-skin-type-5--v1.png"
                alt=""
              />
            </div>
            <div className="chatbox__content--header">
              <h4 className="chatbox__heading--header">Chat support</h4>
              <p className="chatbox__description--header">
                Hi, I'm Errie. How can I help you today?
              </p>
            </div>
          </div>

          {/* Messages Section */}
          <div className="chatbox__messages">
            {messages.slice().reverse().map((message, index) => (
              <div
                key={index}
                className={`messages__item ${
                  message.name === 'Errie'
                    ? 'messages__item--visitor'
                    : 'messages__item--operator'
                }`}
              >
                {message.message}
              </div>
            ))}
          </div>

          {/* Footer - Input and Send Button */}
          <div className="chatbox__footer">
            <input
              type="text"
              placeholder="Write a message..."
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyUp={handleKeyUp}
            />
            <button className="chatbox__send--footer send__button" onClick={handleSendMessage}>
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
